import React from 'react'
import { withStyles } from '@material-ui/core'
import NonAttachmentView from 'src/components/non-attachment-view'
import AttachmentView from 'src/components/attachment-view'
import styles from './styles'

const AttachmentUploader = ({
  classes,
  attachments,
  fileInputRef,
  onUploadFile,
  loading,
}) => {
  const handleOnDropFile = e => {
    e.preventDefault()
    const file = e.dataTransfer.files[0]
    if (file) {
      onUploadFile(file)
    }
  }

  const handleFileSelect = e => {
    const selectedFile = e.target.files[0]
    if (selectedFile) {
      onUploadFile(selectedFile)
    }
  }

  return attachments.length > 0 ? (
    <AttachmentView
      attachments={attachments}
      handleOnDropFile={handleOnDropFile}
      fileInputRef={fileInputRef}
      handleFileSelect={handleFileSelect}
      attachmentLoading={loading}
    />
  ) : (
    <NonAttachmentView
      handleOnDropFile={handleOnDropFile}
      fileInputRef={fileInputRef}
      handleFileSelect={handleFileSelect}
      attachmentLoading={loading}
    />
  )
}

export default withStyles(styles)(AttachmentUploader)
